import {
  SIGNIN_SUCCESS,
  VERIFY_TYPE,
  SAVE_NUMBER_CODE,
  USER_DATA,
  SAVE_USERS_FORGET,
  NOTIFICATION_STATUS,
  RTL_LAYOUT,
  SET_LANGUAGE,
  LOCK_SYSTEM,
  UNLOCK_SYSTEM,
  SET_PRECISION,
} from "Stores/actionTypes";
import { storeToken } from "Helpers/Token";
import { read, remove, store } from "Helpers/LocalStorage";
import { analyzeToken } from "Helpers/analyzeToken";
import StatusHandler from "Helpers/StatusHandler";
import { push } from "Helpers/History";
import AuthService from "Services/http/endpoints/AuthService";
import NotificationsService from "../../Services/http/endpoints/notifications/NotificationsService";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import { faMessages } from "Languages/locales/fa_IR";
import { enMessages } from "Languages/locales/en_US";

export const signInUser = (data) => {
  return async (dispatch) => {
    try {
      const response = await AuthService.signInUser(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        //200 means sign in in 1 step
        if (response.data.StatusCode === 200) {
          const check = read("userId") === data.UserName;
          if (!check) {
            store("project", undefined);
            store("unitId", undefined);
          }
          const { Token, RefreshToken } = response.data.Value;
          storeToken(Token, RefreshToken, true);
          store("userId", data.UserName);
          store("user", "yes");
          analyzeToken(Token);
          dispatch({ type: SIGNIN_SUCCESS });
        } else if (response.data.StatusCode === 220) {
          const check = read("userId") === data.UserName;
          if (!check) {
            store("project", undefined);
            store("unitId", undefined);
          }
          dispatch({
            type: VERIFY_TYPE,
            userId: data.UserName,
            verifyType: "signIn",
            verifyData: response.data.Value,
          });
          push("/auth/verify");
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const authSingUp = (data) => {
  return async (dispatch) => {
    try {
      const response = await AuthService.authSingUp(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: VERIFY_TYPE,
          verifyType: "signUp",
          userId: data.Account,
          signupToken: response.data.Value.Token,
        });
        push("/auth/register");
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const logout = () => {
  const lockStatus = read("isLocked");
  // const project = read("project");
  // const unitId = read("unitId");
  // const userId = read("userId");
  localStorage.clear();
  store("isLocked", lockStatus);
  // store("project", project);
  // store("unitId", unitId);
  // store("userId", userId);
  // store("token", "undefined");
  // push(`/Auth/sign_in`);
  push(`/`);
  window.location.reload();
  // return {
  //   type: AUTH_LOGOUT,
  // };
};

export const authResetPassword = (data) => {
  return async (dispatch) => {
    try {
      const response = await AuthService.authResetPassword(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        if (response.data.StatusCode === 222) {
          dispatch({
            type: VERIFY_TYPE,
            userId: data.Value,
            verifyType: "resetPassword",
            verifyData: response.data.Value,
          });
          push("/auth/verify");
        }
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const verifyAuth = (data, verifyType, header) => {
  return async (dispatch) => {
    try {
      switch (verifyType) {
        case "signIn":
          {
            const resSignIn = await AuthService.verifyAuthSignIn(data, header);
            let errSignIn = StatusHandler(resSignIn);
            if (!errSignIn.isFail) {
              const { Token, RefreshToken } = resSignIn.data.Value;
              storeToken(Token, RefreshToken, true);
              store("userId", data.UserName);
              store("user", "yes");
              analyzeToken(Token);
              dispatch({ type: SIGNIN_SUCCESS });
            }
          }
          break;
        case "resetPassword":
          {
            const resResetPassword = await AuthService.verifyAuthResetPassword(
              data,
              header,
            );
            let err = StatusHandler(resResetPassword);
            if (!err.isFail) {
              if (resResetPassword.data.StatusCode === 222) {
                const { Token, RefreshToken } =
                  resResetPassword.data.Value.TokenResult;

                dispatch({
                  type: SAVE_USERS_FORGET,
                  usersForget: resResetPassword.data.Value.Users,
                });

                storeToken(Token, RefreshToken);
                dispatch({ type: SAVE_NUMBER_CODE, numberCode: data.Code });
                push("/auth/newPassword");
              }
            }
          }
          break;
        case "signUp":
          {
            const resSignUp = await AuthService.verifyAuthSignUp(data);
            let err1 = StatusHandler(resSignUp);
            if (!err1.isFail) {
              const { Token, RefreshToken } = resSignUp.data.Value;
              storeToken(Token, RefreshToken);
              store("userId", data.Account);
              store("user", "yes");
              push("/dashboard");
            }
          }
          break;
        default:
      }
    } catch (e) {
      dispatch({
        type: VERIFY_TYPE,
        userId: null,
        verifyType: null,
        verifyData: null,
      });
    }
  };
};

export const authNewPassword = (data) => {
  return async (dispatch) => {
    try {
      const response = await AuthService.postNewPassword(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf("password_change_successfully"),
          customClass: "success",
        });
        dispatch({
          type: VERIFY_TYPE,
          userId: null,
          verifyType: null,
          verifyData: null,
        });
        storeToken(undefined, undefined, true);
        push("/");
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getUserData = (params) => {
  return async (dispatch) => {
    try {
      if (params.KeyGroup) {
        const response = await AuthService.getUserData(params);
        let err = StatusHandler(response);
        remove("CDW");
        if (!err.isFail) {
          // completely set user data
          faMessages.moneyUnit = response.data.Value.Currency.Sign;
          enMessages.moneyUnit = response.data.Value.Currency.Sign;
          store("precision", response.data.Value.Currency.Precision);
          store(
            "language_direction",
            response.data.Value.Language.IsRTL ? "rtl" : "ltr",
          );
          store("isRTL", response.data.Value.Language.IsRTL);
          dispatch({
            type: SET_PRECISION,
            precision: response.data.Value.Currency.Precision,
          });
          if (read("StypeU") === "1") {
            const information_response =
              await PaymentService.GetRemainTime(params);
            let err_info = StatusHandler(information_response);
            if (!err_info.isFail) {
              const info_data = information_response.data.Value;
              const remaindays =
                info_data.RemaingTime.Years * 365 +
                info_data.RemaingTime.Months * 30 +
                info_data.RemaingTime.Days;
              dispatch({
                type: USER_DATA,
                userData: {
                  ...response.data.Value,
                  panel: {
                    remaindays,
                    credit: info_data.Credit,
                    currentUserCount: info_data.CountUser,
                    end_date: info_data.JalaliDate,
                    currentPeriod: info_data.Period,
                    isFree: info_data.IsFree || false,
                    maxProject: info_data.MaxProject || 0,
                    maxUnit: info_data.MaxUnit || 0,
                  },
                },
              });
            } else {
              dispatch({
                type: USER_DATA,
                userData: response.data.Value,
              });
            }
          } else {
            dispatch({
              type: USER_DATA,
              userData: response.data.Value,
            });
          }

          //! set user language
          switch (response.data.Value.Language.Name) {
            case "Persian":
              dispatch({
                type: SET_LANGUAGE,
                locale: {
                  languageId: "persian",
                  locale: "fa",
                  name: "فارسی",
                  icon: "fa",
                },
              });
              dispatch({
                type: RTL_LAYOUT,
                rtlLayout: true,
              });
              break;
            case "English":
              dispatch({
                type: SET_LANGUAGE,
                locale: {
                  languageId: "english",
                  locale: "en",
                  name: "English",
                  icon: "en",
                },
              });
              dispatch({
                type: RTL_LAYOUT,
                rtlLayout: false,
              });
              break;
          }

          //TODO •••••••• DELETE AFTER TEST ••••••••
          //! ••••••••••• TEST •••••••••••••••••••••
          // const mode_test = 1;
          // switch (mode_test) {
          //   case 1:
          //     dispatch({
          //       type: SET_LANGUAGE,
          //       locale: {
          //         languageId: "persian",
          //         locale: "fa",
          //         name: "فارسی",
          //         icon: "fa",
          //       },
          //     });
          //     dispatch({
          //       type: RTL_LAYOUT,
          //       rtlLayout: true,
          //     });
          //     break;
          //   case 2:
          //     dispatch({
          //       type: SET_LANGUAGE,
          //       locale: {
          //         languageId: "english",
          //         locale: "en",
          //         name: "English",
          //         icon: "en",
          //       },
          //     });
          //     dispatch({
          //       type: RTL_LAYOUT,
          //       rtlLayout: false,
          //     });
          //     break;
          // }
          //! ••••••••••• TEST •••••••••••••••••••••
          //TODO •••••••• DELETE AFTER TEST ••••••••

          // dispatch({
          //   type: RTL_LAYOUT,
          //   rtlLayout: response.data.Value.Language.IsRTL
          // });
          // // set precision
          // //! ALERT -> just add floatPrice={precision} to inputs

          // check user lock-status from local storage | should get from api too
          if (read("isLocked") === "FLSTMM") dispatch(lockSystem());

          // (un)comment just for test
          // dispatch({
          //   type: SET_LANGUAGE,
          //   locale: {
          //     languageId: 'english',
          //     locale: 'en',
          //     name: 'English',
          //     icon: 'en',
          // }
          // });
        }
      } else {
        dispatch({
          type: VERIFY_TYPE,
          userId: null,
          verifyType: null,
          verifyData: null,
        });
        //storeToken(undefined, undefined, true);
        //push("/Auth/sign_in");
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const getNotificationCount = () => {
  return async (dispatch) => {
    try {
      const params = {
        keyGroup: read("groupKey"),
        keyUser: read("userKey"),
      };
      const response = await NotificationsService.getNotificationsCount(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: NOTIFICATION_STATUS,
          count: response.data.Value,
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const postRegister = (data, token) => {
  return async (dispatch) => {
    try {
      const response = await AuthService.postRegister(data, token);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: VERIFY_TYPE,
          userId: null,
          verifyType: null,
          verifyData: null,
          signupToken: null,
        });
        showNotify({
          text: translatorf("registered_successfully"),
          customClass: "success",
        });
        push(`/Auth/sign_in`);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
  };
};

export const lockSystem = () => {
  return (dispatch) => {
    dispatch({ type: LOCK_SYSTEM });
    push(`/maintenance`);
  };
};

export const unlockSystem = () => {
  return (dispatch) => {
    dispatch({ type: UNLOCK_SYSTEM });
    push(`/dashboard`);
  };
};
